import { Download, Package } from 'lucide-react';

export const AdminDownloadCard = ({ item, active, onDownload }) => (
  <article className="rounded-2xl border border-slate-800 bg-slate-900 p-6" data-testid={`admin-download-${item.id}`}>
    <div className="flex items-start justify-between gap-4">
      <div className="w-11 h-11 rounded-xl bg-emerald-500/10 border border-emerald-500/30 flex items-center justify-center flex-shrink-0">
        <Package className="text-emerald-400" size={21} aria-hidden="true" />
      </div>
      <span className="text-xs text-slate-500 font-mono" data-testid={`admin-download-version-${item.id}`}>v{item.version}</span>
    </div>
    <h2 className="text-xl font-bold text-white mt-5" data-testid={`admin-download-name-${item.id}`}>{item.name}</h2>
    <p className="text-sm text-slate-400 leading-relaxed mt-2 min-h-[3.5rem]">{item.description}</p>
    <div className="flex items-center justify-between gap-4 mt-6">
      <span className="text-xs text-slate-600" data-testid={`admin-download-size-${item.id}`}>
        {(item.size_bytes / 1024).toFixed(1)} KB
      </span>
      <button
        type="button"
        onClick={() => onDownload(item)}
        disabled={active}
        data-testid={`admin-download-button-${item.id}`}
        className="rounded-lg bg-emerald-600 hover:bg-emerald-500 disabled:bg-slate-700 disabled:text-slate-500 px-4 py-2 text-sm font-semibold text-white flex items-center gap-2 transition-colors"
      >
        <Download size={16} aria-hidden="true" />
        {active ? 'Preparing…' : 'Download ZIP'}
      </button>
    </div>
  </article>
);
